import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { ChevronRight, Eye } from 'react-feather';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const POItemsTable = ({ data, onSelectItem, onViewShipments }) => {
  const columns = [
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      key: 'itemName',
    },
    {
      title: 'Quantity Requested',
      dataIndex: 'quantityRequested',
      key: 'quantityRequested',
    },
    {
      title: 'Quantity Received',
      dataIndex: 'quantityReceived',
      key: 'quantityReceived',
    },
    {
      title: 'Item Type',
      dataIndex: 'itemType',
      key: 'itemType',
    },
    {
      title: 'Pending',
      key: 'pending',
      render: (_, record) => {
        const requested = Number(record.quantityRequested) || 0;
        const received = Number(record.quantityReceived) || 0;
        const pending = requested - received;
        return pending > 0 ? pending : 0;
      },
    },
    {
      title: 'View Shipments',
      key: 'viewShipments',
      render: (_, record) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`view-shipments-tooltip-${record.poItemDetailID}`}>View Shipments</Tooltip>}
        >
          <button
            className="btn btn-light btn-sm d-flex align-items-center"
            style={{ border: '1px solid #ddd' }}
            onClick={() => onViewShipments && onViewShipments(record.poItemDetailID)}
          >
            <Eye size={16} />
          </button>
        </OverlayTrigger>
      ),
    },
    {
      title: '',
      key: 'actions',
      render: (_, record) => (
        <button
          className="btn btn-sm btn-light"
          onClick={() => onSelectItem(record.poItemDetailID)}
          title="View Releases"
        >
          <ChevronRight size={16} />
        </button>
      ),
    },
  ];

  return <Table columns={columns} dataSource={data} rowKey="poItemDetailID" pagination={false} />;
};

POItemsTable.propTypes = {
  data: PropTypes.array,
  onSelectItem: PropTypes.func.isRequired,
  onViewShipments: PropTypes.func,
};

export default POItemsTable; 